export interface ExcelPhraseRow {
  key: string;
  id?: string;
  local: string;
  fr: string;
  domain: string;
  source: string;
}

export interface ExcelPhraseFormValue {
  local: string;
  fr: string;
  domain: string;
  source: string;
}

export const EMPTY_PHRASE_FORM: ExcelPhraseFormValue = {
  local: '',
  fr: '',
  domain: '',
  source: '',
};
